import { useState } from "react";

import { Route } from "@web-app/types";
import { timeZoneMap } from "@web-app/utils/helpers";

import Button from "../Button";
import DateInput from "../DateInput";
import Modal from "../Modal";

interface CopyRouteModalProps {
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  onCopy: (newDate: Date) => void;
  route: Route;
  timezone?: keyof typeof timeZoneMap;
}

export function CopyRouteModal({
  isLoading,
  isOpen,
  onClose,
  onCopy,
  route,
  timezone,
}: CopyRouteModalProps) {
  const [selectedDate, setSelectedDate] = useState<Date>(
    new Date(route.scheduledDateTime),
  );

  const handleCopy = () => {
    onCopy(selectedDate);
  };

  const routeName = route.externalId || "this route";

  return (
    <Modal
      actions={[
        <Button
          disabled={isLoading}
          key="copy"
          onClick={handleCopy}
          type="button"
        >
          {isLoading ? "Copying..." : "Copy"}
        </Button>,
        <Button key="cancel" onClick={onClose} plain type="button">
          Cancel
        </Button>,
      ]}
      isOpen={isOpen}
      onClose={onClose}
      title="Copy Route"
    >
      <div className="flex flex-col gap-2 px-2 pb-4">
        <p className="text-sm text-gray-600">
          Create a copy of &quot;{routeName}&quot; for a different date. All
          orders will be copied with adjusted dates.
        </p>

        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">
            New Route Start Date and Time
          </label>
          <DateInput
            minDate={new Date()}
            name="newRouteDate"
            onChange={(date) => setSelectedDate(date)}
            position="under"
            timezone={timezone}
            value={selectedDate}
          />
        </div>
      </div>
    </Modal>
  );
}
